import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=13f60e60&scoped=true&"
import script from "./Billings.vue?vue&type=script&lang=js&"
export * from "./Billings.vue?vue&type=script&lang=js&"
import style0 from "./Billings.vue?vue&type=style&index=0&id=13f60e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f60e60",
  null
  
)

component.options.__file = "Billings.vue"
export default component.exports